import React, { Component } from 'react'
import "../App.css"
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route, Switch } from "react-router-dom";
import PersonalInfo from "./PersonalInfo";

import logo from "../abc.png";
// import FinalBiodata from './FinalBiodata';
// import axios from "axios";
// import Path from "./config";
import { Link } from "react-router-dom";
import BasicRegi from './BasicRegi';
import EducationInfo from "./EducationInfo";
import IncomeInfo from "./IncomeInfo";
import FamilyInfo from "./FamilyInfo";
import ContactInfo from "./ContactInfo";
import AssetInfo from "./AssetInfo";
//import NavFormProfile from './NavFormProfile';
import UploadDoc from './UploadDoc';
import Fullbiodata from './Fullbiodata';
import PostAddress from './PostAddress';
import Paddress from './Paddress';
// import axios from "axios";
// import Path from "./config";
import PaymentUpdate from './PaymentUpdate';
import FullbiodataAdmin from './FullbiodataAdmin';
import ShowSuchiList from './ShowSuchiList';
import FullbiodataAdminedit from './FullbiodataAdminedit';
import linkForEdit from './linkForEdit';

export class AdminProfile extends Component {
    constructor(props) {
        super(props)
        this.state = {
            phoneId: null,
            userId: null,
            sbg_first_name: "",
            isPending: true

        }
    }

    componentDidMount() {
        // this.setState({
        //     userId:localStorage.getItem("userId")
        // })
        //localStorage.removeItem('userId');
        this.setState({
            phoneId: localStorage.getItem("phoneId")
        })

        //     axios.get(Path+'Suchi_bride_groom_show_status.php?sbg_id='+localStorage.getItem("userId"))
        //     .then(function (response) {
        //           response=response.data;
        //         // console.log(response)
        //              this.setState({
        //                 //sbg_approved_status : response.sbg_office_appoved_status,
        //                 sbg_first_name:response.sbg_first_name,
        //                 //sbg_admin_approved_status:response.sbg_admin_approved_status,
        //                 //sbg_edu:response.sbg_edu,
        //                 //sbg_income:response.sbg_income,
        //                 //sbg_family:response.sbg_family,
        //                // sbg_relative:response.sbg_relative,
        //                 //sbg_asset:response.sbg_asset,
        //                 //sbg_upload:response.sbg_upload,
        //                  //sbg_post_address:response.sbg_post_address,
        //                 //sbg_summery:response.sbg_summery
        //              } )
        //          }.bind(this))


    }
    //console.log("okkkkkkkkkkkk",props);
    addSuchi = () => {
        localStorage.removeItem('userId');
        this.props.history.push(`/AdminProfile`);
    }
    logouti = () => {
        // alert("logout");
        localStorage.removeItem('admin');
        localStorage.removeItem('adminid');

        this.props.history.push('/Admin');
    }
    render() {


        return (
            <>

                <nav className="navbar navbar-light bg-danger">
                    <div className="container-fluid text-light">
                        <img src={logo} alt="Logo" style={{ width: "170px" }} />

                        <div class="btn-group" role="group" aria-label="Basic outlined example">
                            <Link to="/AdminProfile/ShowSuchiList">
                                <button type="button" class="btn btn-outline-warning">Suchi List </button>
                            </Link>
                            {/* <Link to="/AdminProfile"> */}
                            <button type="button" class="btn btn-outline-warning" onClick={() => this.addSuchi()}> Add New Suchi</button>
                            {/* </Link> */}
                        </div>
                        <form className="d-flex">Welcome Franchisee Name
                            {/* Welcome {this.state.sbg_first_name} !! {this.state.phoneId}  &nbsp;&nbsp;&nbsp; */}
                            <button type="button" className="btn-primary text-light" onClick={() => this.logouti()} >Logout</button>
                        </form>
                    </div>

                </nav>


                <div className="container justify-content-md-center my-5  " data-bs-spy="scroll" data-bs-target="#navbar-example">
                    <div className="bg-light">

                        <div className="border  border-5 border-primary " >
                            <Switch>
                                {/* <Route path="/FormProfile/PersonalInfo" component={PersonalInfo} exact/> */}
                                <Route path={`/AdminProfile`} component={BasicRegi} exact />
                                <Route path={`/AdminProfile/PersonalInfo`} component={PersonalInfo} exact />
                                <Route path={`/AdminProfile/EducationInfo`} component={EducationInfo} exact />
                                <Route path={`/AdminProfile/IncomeInfo`} component={IncomeInfo} exact />
                                <Route path={`/AdminProfile/FamilyInfo`} component={FamilyInfo} exact />
                                <Route path={`/AdminProfile/ContactInfo`} component={ContactInfo} exact />
                                <Route path={`/AdminProfile/AssetInfo`} component={AssetInfo} exact />
                                <Route path={`/AdminProfile/UploadDoc`} component={UploadDoc} exact />
                                <Route path={`/AdminProfile/Fullbiodata`} component={Fullbiodata} exact />
                                <Route path={`/AdminProfile/PostAddress`} component={PostAddress} exact />

                                <Route path={`/AdminProfile/Paddress`} component={Paddress} exact />
                                <Route path={`/AdminProfile/PaymentUpdate`} component={PaymentUpdate} exact />
                                <Route path={`/AdminProfile/FullbiodataAdmin`} component={FullbiodataAdmin} exact />
                                <Route path={`/AdminProfile/FullbiodataAdminedit/:sbg_id`} component={FullbiodataAdminedit} exact />

                                <Route path={`/AdminProfile/ShowSuchiList`} component={ShowSuchiList} exact />

                                <Route path={`/AdminProfile/linkForEdit`} component={linkForEdit} exact />
                            </Switch>
                        </div>

                    </div>

                </div>

            </>
        )
    }
}

export default AdminProfile
